        document.addEventListener('DOMContentLoaded', function() {

          
            const navButtons = {
                palace: document.getElementById('nav-palace'),
                parade: document.getElementById('nav-parade'),
                ending: document.getElementById('nav-ending')
            };

            const contentSections = {
                palace: document.getElementById('content-palace'),
                parade: document.getElementById('content-parade'),
                ending: document.getElementById('content-ending')
            };

            function switchTab(tab) {
                Object.values(navButtons).forEach(btn => btn.classList.remove('active'));
                Object.values(contentSections).forEach(sec => sec.classList.remove('active'));

                navButtons[tab].classList.add('active');
                contentSections[tab].classList.add('active');
            }

            navButtons.palace.addEventListener('click', () => switchTab('palace'));
            navButtons.parade.addEventListener('click', () => switchTab('parade'));
            navButtons.ending.addEventListener('click', () => switchTab('ending'));
            
            // For mobile touch interaction on cards
            const cards = document.querySelectorAll('.character-card');
            cards.forEach(card => {
                card.addEventListener('click', function(e) {
                    // This allows tap to function like hover on touch devices
                    if (window.innerWidth < 1024) {
                       card.classList.toggle('touch-active');
                    }
                });
            });

            // Set initial state
            switchTab('palace');
        
        });

 document.addEventListener("DOMContentLoaded", function () {
    const links = document.querySelectorAll('.language-toggle a');
    links.forEach(link => {
      const current = window.location.pathname.replace(/\/$/, ''); // remove trailing slash
      const target = new URL(link.href).pathname.replace(/\/$/, '');
      if (current === target) {
        link.classList.add('text-orange-600', 'font-semibold', 'border-b', 'border-orange-600');
      }
    });
  });
